import * as React from "react";
import { parseHtml } from "@grandvisionhq/lib-utils-html";
import { ItemList } from "../../../../components/modules/Consents/components/ItemList.js";
const ConsentsContainer = ({ onChange, selectedConsents, consents }) => {
  const getItemLabel = React.useCallback(
    (item) => parseHtml(item.title),
    []
  );
  const getItemIdentifier = React.useCallback(
    (item) => item.value,
    []
  );
  const getItemErrorMessage = React.useCallback((item) => item?.errorMessage || "", []);
  const shouldItemValidate = React.useCallback((item) => item?.shouldValidate || false, []);
  if (!consents?.length) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    ItemList,
    {
      getItemIdentifier,
      getItemLabel,
      getItemErrorMessage,
      shouldItemValidate,
      idPrefix: "consents__",
      items: consents,
      onChange,
      selectedItems: selectedConsents ?? []
    }
  );
};
export {
  ConsentsContainer
};
//# sourceMappingURL=ConsentsContainer.js.map
